import * as React from 'react';
import cn from 'classnames';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const NavigationPointerOutlineIcon = ({ stroke = 'offBlack', size = 'small', className }: IconProps) => {
    const strokeStyles = cn(stroke && Styles[stroke], Styles.stroke);

    return (
        <svg
            data-testid="navigation-pointer-outline-icon"
            xmlns="http://www.w3.org/2000/svg"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 20 20"
            fill="none"
            className={className}
        >
            <path
                d="M1.90748 8.76106C1.34985 8.54421 1.07104 8.43578 0.989636 8.27954C0.919072 8.14411 0.918977 7.98277 0.989382 7.84725C1.0706 7.69092 1.34929 7.58216 1.90666 7.36465L17.7245 1.19184C18.2276 0.995488 18.4792 0.897313 18.64 0.951016C18.7796 0.997654 18.8891 1.10721 18.9358 1.24682C18.9895 1.40757 18.8913 1.65915 18.6949 2.16229L12.5221 17.9801C12.3046 18.5375 12.1959 18.8162 12.0395 18.8974C11.904 18.9678 11.7427 18.9677 11.6072 18.8971C11.451 18.8157 11.3426 18.5369 11.1257 17.9793L8.66411 11.6494C8.62009 11.5363 8.59808 11.4797 8.56409 11.432C8.53396 11.3898 8.49702 11.3528 8.45478 11.3227C8.40712 11.2887 8.35052 11.2667 8.23733 11.2227L1.90748 8.76106Z"
                className={strokeStyles}
                strokeWidth="1.87329"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
